import { Box, styled, Tooltip, type TooltipProps, tooltipClasses } from '@mui/material';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FullLogo } from './FullLogo';
import { SimpleLogo } from './SimpleLogo';

const SIMPLE_LOGO_PAGES = ['/signin', '/signin/', '/force-password/', '/forgot-password', '/password-reset'];

const TooltipWrapper = styled(({ className, children, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}>
    {children}
  </Tooltip>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'LLBrown_Bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow: '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

export function HeaderLogo() {
  const location = useLocation();
  const titleRef = useRef<HTMLAnchorElement | null>(null);

  return (
    <Box component="span">
      <TooltipWrapper title="Avani Solutions" arrow>
        {SIMPLE_LOGO_PAGES.indexOf(location.pathname) > -1 ? (
          <SimpleLogo ref={titleRef} />
        ) : (
          <FullLogo ref={titleRef} />
        )}
      </TooltipWrapper>
    </Box>
  );
}
